export const item = `[&>a]:transition-colors [&>a]:text-primary-100 [&>a]:hover:text-primary-200`;
export const label = `font-semibold`;
